// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/documenti',
    requestBody: '{"file":"File","etichetta":"string"}',
    response: '{"ok":"true","documento":"Documento"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/:id/documenti/:docId/download',
    requestBody: null,
    response: 'file stream (attachment)'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/documenti/:docId',
    requestBody: null,
    response: '{"ok":"true"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
